import { IInitialState } from 'store/models';
import { surveysStateSelector } from './surveysStateSelector';

export function isSurveysLoading(state: IInitialState) {
	return surveysStateSelector(state)?.isLoading;
}
